<template>
  <tr v-if="$parent.$parent.rerender">
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_FIRST_NAME')
      }"
    >
      <input type="hidden" v-model="item.ID" />
      <input
        :disabled="$parent.$parent.projectDisabled"
        class="i-main-style i-contact-style"
        type="text"
        v-model="item.UF_FIRST_NAME"
        v-on:keyup="removeContactError(index, 'UF_FIRST_NAME')"
      />
      <div class="error-text">
        {{ contactErrorText(index, "UF_FIRST_NAME") }}
      </div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_NAME')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        class="i-main-style i-contact-style"
        type="text"
        v-model="item.UF_NAME"
        v-on:keyup="removeContactError(index, 'UF_NAME')"
      />
      <div class="error-text">{{ contactErrorText(index, "UF_NAME") }}</div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_SECOND_NAME')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        class="i-main-style i-contact-style"
        type="text"
        v-model="item.UF_SECOND_NAME"
        v-on:keyup="removeContactError(index, 'UF_SECOND_NAME')"
      />
      <div class="error-text">
        {{ contactErrorText(index, "UF_SECOND_NAME") }}
      </div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_POSITION')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        class="i-main-style i-contact-style"
        type="text"
        v-model="item.UF_POSITION"
        v-on:keyup="removeContactError(index, 'UF_POSITION')"
      />
      <div class="error-text">{{ contactErrorText(index, "UF_POSITION") }}</div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_PHONE1')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        ref="aphonefield"
        class="i-main-style i-contact-style"
        v-model="item.UF_PHONE1"
        @keyup="removeContactError(index, 'UF_PHONE1')"
      />
      <div class="error-text">{{ contactErrorText(index, "UF_PHONE1") }}</div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_PHONE2')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        ref="bphonefield"
        class="i-main-style i-contact-style"
        v-model="item.UF_PHONE2"
        @keyup="removeContactError(index, 'UF_PHONE2')"
      />
      <div class="error-text">{{ contactErrorText(index, "UF_PHONE2") }}</div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_EMAIL1')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        class="i-main-style i-contact-style"
        type="text"
        ref="aemailfield"
        v-model="item.UF_EMAIL1"
        @keyup="removeContactError(index, 'UF_EMAIL1')"
      />
      <div class="error-text">{{ contactErrorText(index, "UF_EMAIL1") }}</div>
    </td>
    <td
      v-bind:class="{
        'has-error': hasContactError(index, 'UF_EMAIL2')
      }"
    >
      <input
        :disabled="$parent.$parent.projectDisabled"
        class="i-main-style i-contact-style"
        type="text"
        ref="cemailfield"
        v-model="item.UF_EMAIL2"
        v-on:keyup="removeContactError(index, 'UF_EMAIL2')"
      />
      <div class="error-text">{{ contactErrorText(index, "UF_EMAIL2") }}</div>
    </td>
    <td v-if="has_del == true">
      <a
        v-show="!$parent.$parent.projectDisabled"
        v-on:click="$parent.deleteContact(index)"
        class="link-delete-row"
      ></a>
    </td>
  </tr>
</template>

<script>
import MaskedInput from "vue-masked-input";
import Inputmask from "inputmask";
import Vue from "vue";

export default {
  props: ["item", "has_del", "index"],
  name: "contacts",
  components: {
    MaskedInput
  },
  methods: {
    hasContactError(col, field) {
      if (typeof this.$parent.$parent.contactErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.contactErrors[col][field] !== "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    contactErrorText(col, field) {
      if (typeof this.$parent.$parent.contactErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.contactErrors[col][field] !== "undefined"
        ) {
          return this.$parent.$parent.contactErrors[col][field];
        }
      }
      return "";
    },
    removeContactError(col, field) {
      if (typeof this.$parent.$parent.contactErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.contactErrors[col][field] !== "undefined"
        ) {
          Vue.delete(this.$parent.$parent.contactErrors[col], field);
        }
      }
      return false;
    }
  },
  mounted() {
    var im = new Inputmask({
      mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
      greedy: false,
      onBeforePaste: function(pastedValue) {
        pastedValue = pastedValue.toLowerCase();
        return pastedValue.replace("mailto:", "");
      },
      definitions: {
        "*": {
          validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]",
          casing: "lower"
        }
      }
    });
    im.mask(this.$refs.aemailfield);
    im.mask(this.$refs.cemailfield);

    var phonemask = new Inputmask({
      mask: "+7 (999) 999-99-99",
      greedy: false,
      definitions: {
        "*": {
          validator: "[0-9-]",
          casing: "lower"
        }
      }
    });
    phonemask.mask(this.$refs.aphonefield);
    phonemask.mask(this.$refs.bphonefield);
  }
};
</script>

<style scoped></style>
